import { LONG_EM_DASH } from "@single-js/common/util/symbols";
import { format } from "date-fns";
export function formatBatchTimestamp(batch) {
    if (batch.timestamp) {
        return format(batch.timestamp, "HH:mm:ss, YYYY/MM/DD");
    }
    else {
        return LONG_EM_DASH;
    }
}
